import api from './api'

interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
}

interface ChatContext {
  userRole: string
  currentPage: string
  userName: string
}

export const chatService = {
  async send(message: string, history: ChatMessage[], context: ChatContext) {
    const { data } = await api.post('/chat', { message, history, context })
    return data.data as { content: string }
  },
}
